
export const formFields = {
  attributeValues: {
    key: 'attributeValues',
    type: 'text',
    label: 'Values',
    required: true,
    placeholder: 'Values',
    requiredMessage: 'Values is required.',
    displayLayout: 'col-md-7',
    tooltip: '<div> Values </div>',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 characters allowed.',
    pattern: /^(?=.*?[A-Za-z0-9]).{1,}$/,
    spaceNotAllowed: true,
  }
};

export const confirmationMessage = {
  action: {
    confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
    type: 'Confirmation'
  }
};

export const successfullyMessage = {
  action: {
    confirmationMessage: 'Successfully Saved Attribute Value',
    type: 'alert',
  }
};

export const attributeAlreadyExistsMessage = {
  action: {
    confirmationMessage: 'Attribute already exists',
    type: 'alert',
  }
};

export const options = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number' },
    { id: 2, name: 'value', label: 'Value', sortable: true, type: 'string' },
  ],

  actions: [
    {
      type: 'edit',
      text: '',
      icon: 'mdi mdi-pencil',
      tooltip: 'Edit'
    }],
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};
